import React from 'react';
import { useIsMobile } from '../../../hooks/use-mobile';

export const FormCard = ({ children }) => {
  const isMobile = useIsMobile();

  return (
    <div style={{
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      padding: isMobile ? '20px 16px' : '32px 24px',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    }}>
      {children}
    </div>
  );
};

export default FormCard;
